import React, { useEffect, useState } from "react";
import { Table, Input, Button, Menu, Dropdown, Switch, Col, Row, Spin } from "antd";
import ConfigurarEmpleadosContactoModal from "./ConfigurarEmpleadosContactoModal";
import { MoreOutlined } from "@ant-design/icons";
import { onSnapshot, collection } from "firebase/firestore";
import { auth, firestore } from "../../firebase";
import { useAuth } from "../Context";
import FiltroSucursal from "../sucursales/FiltroSucursal";
import { useNotification } from "../NotificationContext";
import auditedServices from "../../servicios/clientes/serviciosAudit";
const { actualizarStatus } = auditedServices;
import Title from "antd/es/typography/Title";

const { Search } = Input;

const BuscarCliente = () => {
  const [clientes, setClientes] = useState([]);
  const [filteredClientes, setFilteredClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const { sucursal, isAdmin, role } = useAuth();
  const [sucursalFiltro, setSucursalFiltro] = useState(sucursal || "");
  const [searchText, setSearchText] = useState("");
  const [uploading, setUploading] = useState(null);
  const openNotificationWithIcon = useNotification();

  useEffect(() => {
    // Nueva estructura: cliente en raíz, filtrar por sucursal
    const q = collection(firestore, `cliente`);
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const clientesData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      // Filtrar por sucursal seleccionada
      const filtered = sucursalFiltro ? clientesData.filter(c => c.sucursal === sucursalFiltro) : clientesData;
      setClientes(filtered);
      setFilteredClientes(filtered);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [sucursalFiltro]);
  // ...existing code...
  <FiltroSucursal onSucursalChange={setSucursalFiltro} value={sucursalFiltro} />

  const [modalVisible, setModalVisible] = useState(false);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);

  const menu = (record) => (
    <Menu>
      <Menu.Item onClick={() => handleEditar(record)}>Editar</Menu.Item>
      <Menu.Item onClick={() => handleNuevoAcceso(record)}>Nuevo acceso</Menu.Item>
      {isAdmin && <Menu.Item onClick={() => handleVerAccesos(record)}>Ver accesos</Menu.Item>}
      {isAdmin && <Menu.Item onClick={() => { setClienteSeleccionado(record); setModalVisible(true); }}>Configurar empleados de contacto</Menu.Item>}
    </Menu>
  );

  const columns = [
    {
      title: "Razón Social",
      dataIndex: "razon_social",
      key: "razon_social"
    },
    {
      title: "RFC",
      dataIndex: "rfc",
      key: "rfc",
    },
    {
      title: "Celular",
      dataIndex: "celular",
      key: "celular",
    },
    {
      title: "Contacto",
      dataIndex: "contacto",
      key: "contacto",
    },
    {
      title: "Status",
      dataIndex: "estatus",
      key: "estatus",
      render: (text, record) => {
        const status = record.estatus === "Activo" ? true : false;
        return <>
        {uploading === record.rfc ? <Spin></Spin> : 
        <>
          <Switch
          checked={status}
          onChange={(checked) => handleStatusChange(record, checked)}
          />
        </>
        }
        </>
      }
    },
    {
      title: "Fecha de Creación",
      dataIndex: "creacion",
      key: "creacion",
    },
    {
      title: "Opciones",
      key: "opciones",
      render: (text, record) => (
        <Dropdown overlay={menu(record)} trigger={['click']}>
          <Button icon={<MoreOutlined />} />
        </Dropdown>
      ),
    },
  ];

  const handleStatusChange = async (record, checked) => {
    setUploading(record.rfc);
  // ...
    const body = {
      cliente: record.id,
      status: checked ? "Activo" : "Inactivo",
      sucursal,
    };
    
    if (record.area && record.area.length) body['areas']= [record.area]
    try {
      const token = await auth.currentUser.getIdToken(true);
      const response = await actualizarStatus(token, body);
      if (response.success) {
        openNotificationWithIcon(
          "success",
          "Éxito",
          `Se ${body.estatus} cliente ${record.razon_social}.`
          );
        } else {
          openNotificationWithIcon(
            "warning",
            "Algo salió mal",
            response.error.msg ? response.error.msg : response.error
            );
          }
        } catch (error) {
          openNotificationWithIcon(
            "error",
            "Algo salió mal",
            `El cliente ${record.razon_social} no se ${body.estatus.toLowerCase()}.`
            );
            console.error("Error: ", error);
          }
          setUploading(null);
        };
        
        const handleVerAccesos = (cliente) => {
        };
        
        const handleNuevoAcceso = (cliente) => {
          
        };
        
        const handleEditar = (cliente) => {
  };

  const filteredData = clientes.filter(
    (item) =>
      item.razon_social.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <>
      <Title level={3} className="ccg-center" style={{ marginBottom: 24 }}>
        Información de Clientes
      </Title>
      <Row gutter={16} style={{ marginBottom: 16, flexWrap: 'wrap', alignItems: 'center' }}>
        <Col xs={24} md={8} style={{ marginBottom: 8 }}>
          <FiltroSucursal onSucursalChange={setSucursalFiltro} value={sucursalFiltro} />
        </Col>
        <Col xs={24} md={8} style={{ marginBottom: 8 }}>
          <Search
            placeholder="Buscar por razón social"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </Col>
      </Row>
      <Table
        rowKey="rfc"
        columns={columns}
        dataSource={filteredData}
        loading={loading}
        pagination
        locale={{
          emptyText: "No hay clientes",
          filterConfirm: "Aceptar",
          filterReset: "Reiniciar",
          selectAll: "Seleccionar todo",
          selectInvert: "Invertir selección",
          sortTitle: "Ordenar",
          filterTitle: "Filtro",
          filterEmptyText: "No hay filtros",
          triggerDesc: "Ordenar descendente",
          triggerAsc: "Ordenar ascendente",
          cancelSort: "Cancelar",
        }}
      />
      <ConfigurarEmpleadosContactoModal
        visible={modalVisible}
        onClose={() => { setModalVisible(false); setClienteSeleccionado(null); }}
        cliente={clienteSeleccionado?.id}
        sucursal={sucursalFiltro}
      />
    </>
  );
};

export default BuscarCliente;
